/* eslint-disable import/prefer-default-export */
export const LOADING = 'loading';
export const LOADED = 'loaded';
export const ERROR = 'error';

export const AUTHENTICATING = 'authenticating';
export const SUCCESS = 'success';
export const FAILED = 'failed';

/* eslint-enable import/prefer-default-export */
